import React from 'react'
import { AIRLINE_ENGINEER_USER, IMPERSONATOR_USER } from './constants/UserTypeConstants'
import Tooltip from '@mui/material/Tooltip'
import styled from 'styled-components'

const RestrictedItems = styled.div`
    color: #b51029;
    font-weight: bold;
    border-bottom: 1px dotted black;
    margin: 5px 0;
`

export default function Restricted(props) {
    const { userInfo, details } = props

    return (
        userInfo &&
            [AIRLINE_ENGINEER_USER, IMPERSONATOR_USER].includes(userInfo.role) &&
            details?.restrictedCustomers?.length > 0 ? (
            <RestrictedItems>
                <Tooltip
                    title={(
                        <span style={{ fontSize: '12px', color: 'white', lineHeight: '18px' }}>
							<div>Sellable to customer(s):</div>
                            {details?.restrictedCustomers?.map(r => (<div key={r.customerIdP21}>{r.name} ({r.customerIdP21})</div>))}
                        </span>
                    )}
                >
                    <div>Restricted Item &#x1F6C8;</div>
                </Tooltip>
            </RestrictedItems>
        ) : null
    )
}
